import React from 'react';
import TextField from '@mui/material/TextField';
import MaskedInput from 'react-text-mask';

function MaskTelefone(props) {
  const { value, onChange, ...otherProps } = props;

  // Defina a máscara para o telefone, por exemplo, (99) 999999999
  const mask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];

  return (
    <MaskedInput
      mask={mask}
      guide={false} // Impede a exibição automática da máscara enquanto o usuário digita
      value={value}
      onChange={(e) => {
        onChange({ target: { id: e.target.id, name: e.target.name, value: e.target.value.replace(/[^\d]/g, '') } }); // Remove todos os caracteres não numéricos
      }}
      render={(ref, props) => (
        <TextField
          inputRef={ref}
          {...otherProps}
          {...props}
        />
      )}
    />
  );
}

export default MaskTelefone;